import { render, staticRenderFns } from "./SettlementCarousel.vue?vue&type=template&id=65e72e6f&scoped=true"
import script from "./SettlementCarousel.vue?vue&type=script&lang=js"
export * from "./SettlementCarousel.vue?vue&type=script&lang=js"
import style0 from "./SettlementCarousel.vue?vue&type=style&index=0&id=65e72e6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e72e6f",
  null
  
)

export default component.exports